import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import RefreshAds from './RefreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertBetweenDiscussionsAds() {
  const AdCode = app.data['nagusi-ext-ads.ad-code.between_discussions'];
  const Script = app.data['nagusi-ext-ads.ad-code.between_discussions.js'];
  const Offset = parseInt(app.data['nagusi-ext-ads.between-discussions-offset']) || 3;
  const Frequency = parseInt(app.data['nagusi-ext-ads.between-discussions-frequency']) || 20;
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  override(DiscussionList.prototype, 'view', function (originalView) {
    if (areAdsBypassed()) return originalView();
    let originalVnode;
    try {
      originalVnode = originalView();
    } catch (e) {
      return null;
    }
    try {
      if (!originalVnode || !originalVnode.children || !Array.isArray(originalVnode.children)) {
        return originalVnode;
      }

      // Find the UL that contains the discussions (more robust search)
      const listContainer = originalVnode.children.find(c => c && c.tag === 'ul' && c.attrs && (c.attrs.className?.includes('DiscussionList-discussions') || c.attrs.class?.includes('DiscussionList-discussions')));
      if (!listContainer || !listContainer.children) {
        return originalVnode;
      }

      // Flarum renders discussions in pages using Mithril Fragments (tag === '[').
      // We need to recursively extract all real Vnodes from arrays and fragments to correctly count and inject ads.
      const extractItems = vnodes => {
        let extracted = [];
        for (const vnode of vnodes) {
          if (!vnode) continue;
          if (Array.isArray(vnode)) {
            extracted = extracted.concat(extractItems(vnode));
          } else if (vnode.tag === '[') {
            // Mithril Fragment
            extracted = extracted.concat(extractItems(vnode.children || []));
          } else {
            extracted.push(vnode);
          }
        }
        return extracted;
      };
      const items = extractItems(Array.isArray(listContainer.children) ? listContainer.children : [listContainer.children]);
      const newItems = [];
      let discussionCount = 0;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (!item) continue;
        newItems.push(item);
        discussionCount++;

        // If current position is exactly at Offset or (Offset + N * Frequency)
        if (discussionCount >= Offset && (discussionCount - Offset) % Frequency === 0) {
          newItems.push(m("li", {
            className: "DiscussionList-item nagusi-ad-discussion-item",
            key: `nagusi-ad-discussion-${discussionCount}`
          }, m("div", {
            className: "nagusi-ad nagusi-ad-between-discussions",
            style: {
              textAlign: 'center',
              margin: '15px 0'
            }
          }, Html)));
        }
      }
      listContainer.children = newItems;
      return originalVnode;
    } catch (e) {
      return originalVnode;
    }
  });
  extend(DiscussionList.prototype, ['onupdate', 'oncreate'], () => {
    if (areAdsBypassed() || dev) return;
    RefreshAds();
    safelyEvalAdScript('between discussions', Script);
  });
}